import React from "react";
import { Typography } from "@mui/material";
import { Link, Edit } from "@mui/icons-material";
import { IconButton, Skeleton } from "@mui/material";

const iconStyle = {
  position: "absolute",
  left: "-2.5rem",
};

export default function InvoiceField({
  label,
  value,
  onNavigate,
  onEdit,
  fontSize,
  loading,
}) {
  return (
    <div style={{ position: "relative", textAlign: "left" }}>
      {onNavigate != null ? (
        <IconButton onClick={onNavigate} sx={iconStyle}>
          <Link sx={{ fontSize: "1.2rem" }} color="primary" />
        </IconButton>
      ) : null}
      {onEdit != null ? (
        <IconButton onClick={onEdit} sx={iconStyle}>
          <Edit sx={{ fontSize: "1.2rem" }} color="primary" />
        </IconButton>
      ) : null}
      <Typography fontSize={fontSize != null ? fontSize : 12}>
        {label}
      </Typography>
      <Typography
        fontSize={fontSize != null ? fontSize : 16}
        textOverflow={"ellipsis"}
        overflow={"hidden"}
        title={value}
        color={"black"}
      >
        {loading ? <Skeleton height={32} /> : value ? value : "-"}
      </Typography>
    </div>
  );
}
